import { useEffect, useState } from 'react';
import { Project, ProjectAPI } from '@brg/api';
export var useGetProjectListById = function (id) {
    var _a = useState(null), project = _a[0], setProject = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    useEffect(function () {
        if (!id) {
            setProject(null);
            return;
        }
        setLoading(true);
        ProjectAPI.Get({
            idProject: id
        })
            .then(function (r) { return r.json(); })
            .then(function (r) {
            setProject(r || null);
            setLoading(false);
        })
            .catch(function (error) {
            console.error(error);
            setError(true);
            setLoading(false);
        });
    }, [id]);
    return {
        project: project,
        loading: loading,
        error: error
    };
};
//# sourceMappingURL=useGetProjectListById.js.mapimport { useEffect, useState } from 'react';
import { Project, ProjectAPI } from '@brg/api';
export var useGetProjectListById = function (id) {
    var _a = useState(null), project = _a[0], setProject = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    useEffect(function () {
        if (!id) {
            setProject(null);
            return;
        }
        setLoading(true);
        ProjectAPI.Get({
            idProject: id
        })
            .then(function (r) { return r.json(); })
            .then(function (r) {
            setProject(r || null);
            setLoading(false);
        })
            .catch(function (error) {
            console.error(error);
            setError(true);
            setLoading(false);
        });
    }, [id]);
    return {
        project: project,
        loading: loading,
        error: error
    };
};
//# sourceMappingURL=useGetProjectListById.js.map